import getMuiTheme from 'material-ui/styles/getMuiTheme';

const theme =  {
  darkPrimaryColor: "#0288d1",
  defaultPrimaryColor: "#039be5",
  lightPrimaryColor: "#039be5",
  textPrimaryColor: "#FFFFFF",
  accentColor: "#607D8B",
  primaryTextColor: "rgba(0,0,0,0.6)", //"#212121",
  secondaryTextColor: "#757575",
  dividerColor: "#BDBDBD"
}

export default getMuiTheme({
  palette: {

    primary1Color: theme.defaultPrimaryColor,
    primary2Color: theme.darkPrimaryColor,
    primary3Color: theme.lightPrimaryColor,
    accent1Color: theme.accentColor,
    accent2Color: theme.accentColor,
    accent3Color: theme.accentColor,
    textColor: theme.primaryTextColor,
    alternateTextColor: theme.textPrimaryColor,
    canvasColor: theme.textPrimaryColor,
    borderColor: theme.dividerColor,
    pickerHeaderColor: theme.primaryTextColor,
    
  },
  toolbar: {
      color: "#000",
      height: 50,
      position: "absolute",
  },
});



// WEBPACK FOOTER //
// ./src/theme.js